// import React, { useEffect, useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import "swiper/css";
// import "swiper/css/pagination";
// import "swiper/css/navigation";
// import { fetchcategorylist } from "./Apiservice";
// import { Pagination, Navigation, Autoplay } from "swiper/modules";
// import Notification from "./Notification";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import { createFavorite } from "./Apiservice";
// import { FaHeart } from "react-icons/fa";
// import { FaRegHeart } from "react-icons/fa6";
// import Loading from "./Loading";
// import { Button } from "bootstrap";
// import Subscribe from "../Mainpages/Subscribe";
// import WhatsAppChatWidget from "./WhatsAppChatWidget";

// const Home = () => {
//   const [categories, setCategories] = useState([]);
//   const [products, setProducts] = useState([]);
//   const [bestsellerProducts, setBestsellerProducts] = useState([]);
//   const [latestcollection, setLatestcollection] = useState([]);

//   const [pageloading, setPageloading] = useState(true);
//   const [visibleItems, setVisibleItems] = useState(
//     window.innerWidth <= 768 ? 8 : 12, // Initial state based on screen size
//   );
//   useEffect(() => {
//     window.scrollTo(0, 0); // Scroll to the top when the component mounts
//   }, []);
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, []);
//   useEffect(() => {
//     const updateVisibleItems = () => {
//       // Set the number of items to display based on screen width
//       setVisibleItems(window.innerWidth <= 768 ? 8 : 12);
//     };

//     window.addEventListener("resize", updateVisibleItems);

//     return () => {
//       window.removeEventListener("resize", updateVisibleItems);
//     };
//   }, []);

//   useEffect(() => {
//     const getCategories = async (id) => {
//       try {
//         const data = await fetchcategorylist(id);
//         setCategories(data);
//       } catch (error) {
//         console.error("Failed to fetch categories:", error);
//       } finally {
//         setPageloading(false); // Set loading to false after data is fetched
//       }
//     };
//     getCategories();
//   }, []);

//   const settings = {
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     dots: true,
//     autoplay: true,
//     speed: 500,
//     infinite: true,
//   };

//   useEffect(() => {
//     const fetchProducts = async () => {
//       try {
//         const response = await axios.get(
//           "https://vishushethra.com/api/api/featured-products/",
//         );
//         setProducts(response.data);
//       } catch (error) {
//         console.error("Error fetching products:", error);
//       }
//     };

//     fetchProducts();
//   }, []);
//   useEffect(() => {
//     const fetchbestsellerProducts = async () => {
//       try {
//         const response = await axios.get(
//           "https://vishushethra.com/api/api/best-sellers/",
//         );
//         setBestsellerProducts(response.data);
//       } catch (error) {
//         console.error("Error fetching products:", error);
//       }
//     };

//     fetchbestsellerProducts();
//   }, []);
//   useEffect(() => {
//     const fetchlatestcollection = async () => {
//       try {
//         const response = await axios.get(
//           "https://vishushethra.com/api/api/latest-collection/",
//         );
//         setLatestcollection(response.data);
//       } catch (error) {
//         console.error("Error fetching products:", error);
//       }
//     };

//     fetchlatestcollection();
//   }, []);

//   const [openIndex, setOpenIndex] = useState(null);

//   const toggleAccordion = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   const faqItems = [
//     {
//       question: "Why choose Vishushetra steel products?",
//       answer:
//         "Vishushetra steel products are manufactured using high-quality raw materials and advanced processes to ensure strength, durability, and long service life. Our products meet industry standards and are trusted for construction, fabrication, and industrial applications.",
//     },
//     {
//       question: "What makes Vishushetra steel plates unique?",
//       answer:
//         "Our steel plates are precision-engineered for uniform thickness, excellent load-bearing capacity, and superior resistance to wear and corrosion. This makes them suitable for heavy-duty and long-term usage across multiple industries.",
//     },
//     {
//       question: "Are Vishushetra steel products suitable for industrial use?",
//       answer:
//         "Yes, Vishushetra steel products are widely used in industrial, construction, and fabrication sectors. They are designed to perform reliably under demanding conditions and comply with modern industrial requirements.",
//     },
//     {
//       question: "Do you ensure quality control for steel products?",
//       answer:
//         "Every Vishushetra steel product undergoes strict quality checks to ensure consistency, strength, and safety. Our commitment to quality ensures dependable performance in every project.",
//     },
//   ];

//   const [selectedProduct, setSelectedProduct] = useState(null);

//   const [favorites, setFavorites] = useState([]);

//   const toggleFavorite = (productId) => {
//     if (favorites.includes(productId)) {
//       setFavorites(favorites.filter((id) => id !== productId)); // Remove from favorites
//     } else {
//       setFavorites([...favorites, productId]); // Add to favorites
//     }
//   };
//   const handleAddToFavorites = async (productId) => {
//     const userId = localStorage.getItem("userId"); // Get userId from local storage
//     if (userId) {
//       try {
//         await createFavorite(userId, productId);

//         Swal.fire({
//           icon: "success",
//           title: "Add Cart",
//           text: "Product added to favorites successfully",
//         });
//       } catch (error) {
//         Swal.fire({
//           icon: "error",
//           title: "Error",
//           text: "Failed to add favorites.",
//         });
//         console.error("Error adding to favorites:", error);
//       }
//     } else {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Please log in to add favorites.",
//       });
//     }
//   };
//   if (pageloading) {
//     return <Loading />;
//   }

//   return (
//     <div>
//       <section className="slider_section mb-0">
//         <Slider {...settings} className="slider_area">
//           <div>
//             <div className="single_slider d-flex align-items-center banner">
//               <div className="container">
//                 <div className="row justify-content-start">
//                   <div className="col-lg-7 col-md-5 ">
//                     <div
//                       className="slider_text d-flex flex-column align-items-center justify-content-center text-center mt-5"
//                       style={{
//                         color: "white",
//                         backgroundColor: "rgba(0, 0, 0, 0.5)",
//                         padding: "20px",
//                       }}
//                     >
//                       <h1>
//                         Premium steel plates
//                         <br></br> built for strength
//                         <br></br> and durability.
//                       </h1>

//                       <Link
//                         className="btn btn-primary"
//                         to="/Latestcollection"
//                         style={{ marginTop: "0px" }}
//                       >
//                         Shop Now
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div>
//             <div className="single_slider d-flex align-items-center banner1">
//               <div className="container">
//                 <div className="row justify-content-start">
//                   <div className="col-lg-5 col-md-7 ">
//                     <div
//                       className="slider_text d-flex flex-column align-items-center justify-content-left text-center mt-5"
//                       style={{
//                         color: "white",
//                         backgroundColor: "rgba(0, 0, 0, 0.5)",
//                         padding: "20px",
//                       }}
//                     >
//                       <h1>
//                         Precision steel solutions <br></br>for modern
//                         industries.
//                       </h1>

//                       <Link
//                         className="btn btn-primary"
//                         to="/Latestcollection"
//                         style={{ marginTop: "0px" }}
//                       >
//                         Shop Now
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div>
//             <div className="single_slider d-flex align-items-center banner2">
//               <div className="container">
//                 <div className="row justify-content-end">
//                   <div className="col-lg-7 col-md-7 ">
//                     <div
//                       className="slider_text d-flex flex-column align-items-center justify-content-center text-center mt-5"
//                       style={{
//                         color: "white",
//                         backgroundColor: "rgba(0, 0, 0, 0.5)",
//                         padding: "20px",
//                       }}
//                     >
//                       <h1>
//                         Trusted steel products <br></br> for every project.
//                       </h1>

//                       <Link
//                         className="btn btn-primary"
//                         to="/Latestcollection"
//                         style={{ marginTop: "0px" }}
//                       >
//                         Shop Now
//                       </Link>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Slider>
//       </section>

//       <section className="product_area related_products mb-20 bg-light">
//         <div className="container">
//           <div className="row">
//             <div className="col-12 mt-2">
//               <div className="section_title mb-25 ">
//                 <h2>Shop By Category</h2>
//               </div>
//             </div>
//           </div>

//           <div className="product_container row">
//             {categories.map((category) => (
//               <div className="col-lg-3" key={category.id}>
//                 <article className="single_product" id="Categorycard">
//                   <figure>
//                     <div className="product_thumb">
//                       <Link to={`/product/${category.id}`}>
//                         <img
//                           className="primary_img"
//                           src={category.image || "default-image.jpg"} // Default image fallback
//                           alt={category.name}
//                         />
//                       </Link>
//                     </div>
//                     <figcaption className="product_content text-center">
//                       <h4 className="product_name">
//                         <Link to={`/category/${category.id}`}>
//                           {category.name}
//                         </Link>
//                       </h4>
//                     </figcaption>
//                   </figure>
//                 </article>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       <section className="product_area related_products mb-5">
//         <div className="container">
//           <div className="row">
//             <div className="col-12">
//               <div className="section_title mb-50">
//                 <h2>Our Trending products</h2>
//               </div>
//             </div>
//           </div>

//           <div className="grid-container">
//             {[...latestcollection]
//               .reverse()
//               .slice(0, visibleItems)
//               .map((product) => {
//                 const originalPrice = parseFloat(product.price);
//                 const discountedPrice =
//                   originalPrice -
//                   (originalPrice * product.discount_percentage) / 100;

//                 return (
//                   <div key={product.id} className="grid-item">
//                     <div className="product-thumb">
//                       <Link to={`/Productdetail/${product.id}`}>
//                         {/* Primary Image */}
//                         <img
//                           className="primary-img"
//                           src={product.images[0].image}
//                           alt={product.name}
//                         />
//                         {/* Secondary Image (Only show if available) */}
//                         {product.images[1] && (
//                           <img
//                             className="secondary-img"
//                             src={product.images[1].image}
//                             alt={`${product.name} hover`}
//                           />
//                         )}
//                       </Link>

//                       <div className="product-labels">
//                         {/* {product.is_bogo && (
//                           <div className="product-label bogo">
                           
//                             <span>
//                               Buy {product.buy_quantity} Get{" "}
//                               {product.get_quantity}
//                             </span>
//                           </div>
//                         )}
//                         {product.discount_percentage > 0 && (
//                           <div className="product-label discount">
//                             <span>-{product.discount_percentage}%</span>
//                           </div>
//                         )} */}
//                         {product.offer_type === "buy_x_get_y" && (
//                           <div className="product-label bogo">
//                             <span>
//                               Buy {product.buy_x} Get {product.get_y}
//                             </span>
//                           </div>
//                         )}
//                         {product.offer_type === "discount_percentage" &&
//                           product.discount_percentage !== "0.00" && (
//                             <div className="product-label discount">
//                               <span>-{product.discount_percentage}%</span>
//                             </div>
//                           )}
//                         {product.sold_out && (
//                           <div className="product-label sold-out">
//                             <span>Sold Out</span>
//                           </div>
//                         )}
//                         {product.coming_soon && (
//                           <div className="product-label coming-soon">
//                             <span>Coming Soon</span>
//                           </div>
//                         )}
//                         {product.latest_collection && (
//                           <div className="product-label latest">
//                             <span>Trending</span>
//                           </div>
//                         )}
//                       </div>

//                       <div className="product-action">
//                         <ul>
//                           <li
//                             className="wishlist"
//                             onClick={() => {
//                               handleAddToFavorites(product.id);
//                               toggleFavorite(product.id);
//                             }}
//                           >
//                             <Link to="" title="Wishlist">
//                               {favorites.includes(product.id) ? (
//                                 <FaHeart className="wishlist-icon active" />
//                               ) : (
//                                 <FaRegHeart className="wishlist-icon" />
//                               )}
//                             </Link>
//                           </li>
//                           <li className="quick-view">
//                             <Link
//                               data-toggle="modal"
//                               data-target="#modal_box"
//                               title="Quick View"
//                               to="#"
//                               onClick={() => setSelectedProduct(product)}
//                             >
//                               <i className="icon-size-fullscreen icons"></i>
//                             </Link>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>

//                     <div className="product-content">
//                       <h4 className="product-name">
//                         <Link to={`/Productdetail/${product.id}`}>
//                           {product.name}
//                         </Link>
//                       </h4>
//                       {!product.coming_soon && (
//                         <div className="price-box">
//                           <span className="current-price">
//                             ₹
//                             {discountedPrice.toLocaleString("en-IN", {
//                               minimumFractionDigits: 2,
//                             })}{" "}
//                             <span className="inr">INR</span>
//                           </span>
//                           {product.discount_percentage > 0 && (
//                             <span className="old-price">
//                               ₹
//                               {originalPrice.toLocaleString("en-IN", {
//                                 minimumFractionDigits: 2,
//                               })}{" "}
//                             </span>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>

//           <div className="d-flex justify-content-center">
//             <Link
//               className="btn btn-primary d-flex align-items-center"
//               to="/Latestcollection"
//             >
//               View all
//             </Link>
//           </div>
//         </div>
//       </section>

//       <section className="accordion">
//         <div className="accordion-left">
//           <h1>FAQ</h1>
//           <p>
//             Discover answers to the most common questions about Coco Heal and
//             Beauty Products. If you need further assistance, feel free to reach
//             out to our friendly customer support team!
//           </p>
//         </div>
//         <div className="accordion-right">
//           {faqItems.map((item, index) => (
//             <div key={index} className="accordion-item">
//               <button
//                 className="accordion-header"
//                 onClick={() => toggleAccordion(index)}
//               >
//                 <h3>{item.question}</h3>
//               </button>
//               <div
//                 className={`accordion-content ${
//                   openIndex === index ? "open" : ""
//                 }`}
//               >
//                 <p>{item.answer}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>

//       <section className="product_area related_products mb-5">
//         <div className="container">
//           <div className="row">
//             <div className="col-12">
//               <div className="section_title mb-50">
//                 <h2>Best Seller Products</h2>
//               </div>
//             </div>
//           </div>

//           <div className="grid-container">
//             {[...bestsellerProducts]
//               .reverse()
//               .slice(0, visibleItems)
//               .map((product) => {
//                 const originalPrice = parseFloat(product.price);

//                 const discountedPrice =
//                   originalPrice -
//                   (originalPrice * product.discount_percentage) / 100;

//                 return (
//                   <div key={product.id} className="grid-item">
//                     <div className="product-thumb">
//                       <Link to={`/Productdetail/${product.id}`}>
//                         {/* Primary Image */}
//                         <img
//                           className="primary-img"
//                           src={product.images[0].image}
//                           alt={product.name}
//                         />
//                         {/* Secondary Image (Only show if available) */}
//                         {product.images[1] && (
//                           <img
//                             className="secondary-img"
//                             src={product.images[1].image}
//                             alt={`${product.name} hover`}
//                           />
//                         )}
//                       </Link>
//                       {/* Discount or Sold-Out Labels */}
//                       {/* {product.discount_percentage > 0 && (
//                         <div className="product-label">
//                           <span>-{product.discount_percentage}%</span>
//                         </div>
//                       )}
//                       {product.sold_out && (
//                         <div className="product-label sold-out">
//                           <span>Sold Out</span>
//                         </div>
//                       )} */}

//                       <div className="product-labels">
//                         {/* {product.is_bogo && (
//                           <div className="product-label bogo">
//                             <span>
//                               Buy {product.buy_quantity} Get{" "}
//                               {product.get_quantity}
//                             </span>
//                           </div>
//                         )}
//                         {product.discount_percentage > 0 && (
//                           <div className="product-label discount">
//                             <span>-{product.discount_percentage}%</span>
//                           </div>
//                         )} */}
//                         {product.offer_type === "buy_x_get_y" && (
//                           <div className="product-label bogo">
//                             <span>
//                               Buy {product.buy_x} Get {product.get_y}
//                             </span>
//                           </div>
//                         )}
//                         {product.offer_type === "discount_percentage" &&
//                           product.discount_percentage !== "0.00" && (
//                             <div className="product-label discount">
//                               <span>-{product.discount_percentage}%</span>
//                             </div>
//                           )}
//                         {product.sold_out && (
//                           <div className="product-label sold-out">
//                             <span>Sold Out</span>
//                           </div>
//                         )}
//                         {product.coming_soon && (
//                           <div className="product-label coming-soon">
//                             <span>Coming Soon</span>
//                           </div>
//                         )}
//                         {product.latest_collection && (
//                           <div className="product-label latest">
//                             <span>Trending</span>
//                           </div>
//                         )}
//                       </div>
//                       {/* Product Actions */}
//                       <div className="product-action">
//                         <ul>
//                           <li
//                             className="wishlist"
//                             onClick={() => {
//                               handleAddToFavorites(product.id);
//                               toggleFavorite(product.id);
//                             }}
//                           >
//                             <Link to="" title="Wishlist">
//                               {favorites.includes(product.id) ? (
//                                 <FaHeart className="wishlist-icon active" />
//                               ) : (
//                                 <FaRegHeart className="wishlist-icon" />
//                               )}
//                             </Link>
//                           </li>
//                           <li className="quick-view">
//                             <Link
//                               data-toggle="modal"
//                               data-target="#modal_box"
//                               title="Quick View"
//                               to="#"
//                               onClick={() => setSelectedProduct(product)}
//                             >
//                               <i className="icon-size-fullscreen icons"></i>
//                             </Link>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                     <div className="product-content">
//                       <h4 className="product-name">
//                         <Link to={`/Productdetail/${product.id}`}>
//                           {product.name}
//                         </Link>
//                       </h4>
//                       {!product.coming_soon && (
//                         <div className="price-box">
//                           <span className="current-price">
//                             ₹
//                             {discountedPrice.toLocaleString("en-IN", {
//                               minimumFractionDigits: 2,
//                             })}{" "}
//                             <span className="inr">INR</span>
//                           </span>
//                           {product.discount_percentage > 0 && (
//                             <span className="old-price">
//                               ₹
//                               {originalPrice.toLocaleString("en-IN", {
//                                 minimumFractionDigits: 2,
//                               })}{" "}
//                             </span>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>

//           <div className="d-flex justify-content-center">
//             <Link
//               className="btn btn-primary d-flex align-items-center   "
//               to="/Bestseller"
//             >
//               View all
//             </Link>
//           </div>
//         </div>
//       </section>

//       <section className="testmonial">
//         <div className="testmonial-text">
//           <h1>Client Testimonials</h1>
//           <p>
//             Your trusted partner for premium steel solutions — hear from our
//             satisfied customers.
//           </p>
//           <Swiper
//             spaceBetween={50}
//             slidesPerView={1}
//             pagination={{ clickable: true }}
//             navigation={false}
//             autoplay={{ delay: 3000 }}
//             loop={true}
//             modules={[Pagination, Navigation, Autoplay]}
//           >
//             <SwiperSlide>
//               <div>
//                 <p>
//                   Vishushetra steel plates are exceptionally strong and
//                   reliable. The quality consistency has helped us complete our
//                   projects on time without any issues.
//                 </p>
//                 <h5>Barathidhasan</h5>
//               </div>
//             </SwiperSlide>
//             <SwiperSlide>
//               <div>
//                 <p>
//                   We have been sourcing steel products from Vishushetra for a
//                   long time. Their materials meet industry standards and the
//                   service is always professional.
//                 </p>
//                 <h5>Mugilesh</h5>
//               </div>
//             </SwiperSlide>
//             <SwiperSlide>
//               <div>
//                 <p>
//                   Excellent quality steel with precise finishing. Vishushetra
//                   has become our preferred supplier for all fabrication and
//                   construction requirements.
//                 </p>
//                 <h5>Praveen</h5>
//               </div>
//             </SwiperSlide>
//           </Swiper>
//         </div>
//       </section>

//       <section className="product_area related_products mb-5">
//         <div className="container">
//           <div className="row">
//             <div className="col-12">
//               <div className="section_title mb-50">
//                 <h2>featured Products</h2>
//               </div>
//             </div>
//           </div>

//           <div className="grid-container">
//             {[...products]
//               .reverse()
//               .slice(0, visibleItems)
//               .map((product) => {
//                 const originalPrice = parseFloat(product.price);

//                 const discountedPrice =
//                   originalPrice -
//                   (originalPrice * product.discount_percentage) / 100;

//                 return (
//                   <div key={product.id} className="grid-item">
//                     <div className="product-thumb">
//                       <Link to={`/Productdetail/${product.id}`}>
//                         {/* Primary Image */}
//                         <img
//                           className="primary-img"
//                           src={product.images[0].image}
//                           alt={product.name}
//                         />
//                         {/* Secondary Image (Only show if available) */}
//                         {product.images[1] && (
//                           <img
//                             className="secondary-img"
//                             src={product.images[1].image}
//                             alt={`${product.name} hover`}
//                           />
//                         )}
//                       </Link>
//                       {/* Discount or Sold-Out Labels */}
//                       {/* {product.discount_percentage > 0 && (
//                         <div className="product-label">
//                           <span>-{product.discount_percentage}%</span>
//                         </div>
//                       )}
//                       {product.sold_out && (
//                         <div className="product-label sold-out">
//                           <span>Sold Out</span>
//                         </div>
//                       )} */}

//                       <div className="product-labels">
//                         {/* {product.is_bogo && (
//                           <div className="product-label bogo">
//                             <span>
//                               Buy {product.buy_quantity} Get{" "}
//                               {product.get_quantity}
//                             </span>
//                           </div>
//                         )}
//                         {product.discount_percentage > 0 && (
//                           <div className="product-label discount">
//                             <span>-{product.discount_percentage}%</span>
//                           </div>
//                         )} */}
//                         {product.offer_type === "buy_x_get_y" && (
//                           <div className="product-label bogo">
//                             <span>
//                               Buy {product.buy_x} Get {product.get_y}
//                             </span>
//                           </div>
//                         )}
//                         {product.offer_type === "discount_percentage" &&
//                           product.discount_percentage !== "0.00" && (
//                             <div className="product-label discount">
//                               <span>-{product.discount_percentage}%</span>
//                             </div>
//                           )}
//                         {product.sold_out && (
//                           <div className="product-label sold-out">
//                             <span>Sold Out</span>
//                           </div>
//                         )}
//                         {product.coming_soon && (
//                           <div className="product-label coming-soon">
//                             <span>Coming Soon</span>
//                           </div>
//                         )}
//                         {product.latest_collection && (
//                           <div className="product-label latest">
//                             <span>Trending</span>
//                           </div>
//                         )}
//                       </div>
//                       {/* Product Actions */}
//                       <div className="product-action">
//                         <ul>
//                           <li
//                             className="wishlist"
//                             onClick={() => {
//                               handleAddToFavorites(product.id);
//                               toggleFavorite(product.id);
//                             }}
//                           >
//                             <Link to="" title="Wishlist">
//                               {favorites.includes(product.id) ? (
//                                 <FaHeart className="wishlist-icon active" />
//                               ) : (
//                                 <FaRegHeart className="wishlist-icon" />
//                               )}
//                             </Link>
//                           </li>
//                           <li className="quick-view">
//                             <Link
//                               data-toggle="modal"
//                               data-target="#modal_box"
//                               title="Quick View"
//                               to="#"
//                               onClick={() => setSelectedProduct(product)}
//                             >
//                               <i className="icon-size-fullscreen icons"></i>
//                             </Link>
//                           </li>
//                         </ul>
//                       </div>
//                     </div>
//                     <div className="product-content">
//                       <h4 className="product-name">
//                         <Link to={`/Productdetail/${product.id}`}>
//                           {product.name}
//                         </Link>
//                       </h4>
//                       {!product.coming_soon && (
//                         <div className="price-box">
//                           <span className="current-price">
//                             ₹
//                             {discountedPrice.toLocaleString("en-IN", {
//                               minimumFractionDigits: 2,
//                             })}{" "}
//                             <span className="inr">INR</span>
//                           </span>
//                           {product.discount_percentage > 0 && (
//                             <span className="old-price">
//                               ₹
//                               {originalPrice.toLocaleString("en-IN", {
//                                 minimumFractionDigits: 2,
//                               })}{" "}
//                             </span>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 );
//               })}
//           </div>

//           <div className="d-flex justify-content-center">
//             <Link
//               className="btn btn-primary d-flex align-items-center   "
//               to="/Featured"
//             >
//               View all
//             </Link>
//           </div>
//         </div>
//       </section>

//       <div
//         className="modal fade"
//         id="modal_box"
//         tabIndex="-1"
//         role="dialog"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-dialog-centered" role="document">
//           <div className="modal-content">
//             <button
//               type="button"
//               className="close"
//               data-dismiss="modal"
//               aria-label="Close"
//             >
//               <span aria-hidden="true">
//                 <i className="ion-android-close"></i>
//               </span>
//             </button>
//             {selectedProduct && (
//               <div className="modal_body">
//                 <div className="container">
//                   <div className="row">
//                     <div className="col-lg-6 col-md-6 col-sm-12">
//                       <div className="modal_zoom_gallery">
//                         <div className="big_image_container">
//                           <img
//                             id="bigImage"
//                             src={selectedProduct.images[0].image} // Use selected product image
//                             alt={selectedProduct.name}
//                             className="big_image"
//                           />
//                         </div>
//                         <div className="small_images_container">
//                           {selectedProduct.images.map((img, index) => (
//                             <img
//                               key={index}
//                               src={img.image}
//                               alt={selectedProduct.name}
//                               className="small_image"
//                               onClick={() =>
//                                 (document.getElementById("bigImage").src =
//                                   img.image)
//                               }
//                             />
//                           ))}
//                         </div>
//                       </div>
//                     </div>
//                     <div className="col-lg-6 col-md-6 col-sm-12">
//                       <div className="modal_right">
//                         <div className="modal_title mb-10">
//                           <h2>{selectedProduct.name}</h2>
//                         </div>
//                         <div className="modal_price mb-10 d-flex  align-items-center g-3">
//                           <h5>Price</h5>
//                           <span className="new_price ml-3">
//                             ₹{selectedProduct.price}INR
//                           </span>{" "}
//                         </div>
//                         <div className="modal_description mb-15 d-flex  align-items-center g-3">
//                           <h5>description</h5>
//                           <p className="ml-3">{selectedProduct.description}</p>
//                         </div>
//                         <div className="modal_description mb-15 d-flex  align-items-center g-3">
//                           <h5>fabric</h5>
//                           <p className="ml-3">{selectedProduct.fabric}</p>
//                         </div>
//                         <div className="modal_description mb-15 d-flex  align-items-center g-3">
//                           <h5>style</h5>
//                           <p className="ml-3">{selectedProduct.style}</p>
//                         </div>
//                         <div className="modal_description mb-15 d-flex  align-items-center g-3">
//                           <h5>Model wearing height</h5>
//                           <p className="ml-3">{selectedProduct.model_height}</p>
//                         </div>
//                         <div className="modal_description mb-15 d-flex  align-items-center g-3">
//                           <h5>Model wearing size</h5>
//                           <p className="ml-3">
//                             {selectedProduct.model_wearing_size}
//                           </p>
//                         </div>

//                         <button
//                           className="button btn btn-success py-2"
//                           type="button"
//                         >
//                           Go to Product detail page
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <Notification />

//       <Subscribe />

//       <WhatsAppChatWidget
//         phoneNumber="+918939711577"
//         companyName="VishuShethra Industries"
//       />
//     </div>
//   );
// };

// export default Home;































import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { fetchcategorylist } from "./Apiservice";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import Notification from "./Notification";
import axios from "axios";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { createFavorite } from "./Apiservice";
import { FaHeart } from "react-icons/fa";
import { FaRegHeart } from "react-icons/fa6";
import Loading from "./Loading";
import Subscribe from "../Mainpages/Subscribe";
import WhatsAppChatWidget from "./WhatsAppChatWidget";

const Home = () => {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [bestsellerProducts, setBestsellerProducts] = useState([]);
  const [latestcollection, setLatestcollection] = useState([]);

  const [pageloading, setPageloading] = useState(true);
  const [visibleItems, setVisibleItems] = useState(
    window.innerWidth <= 768 ? 8 : 12, // Initial state based on screen size
  );
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const updateVisibleItems = () => {
      // Set the number of items to display based on screen width
      setVisibleItems(window.innerWidth <= 768 ? 8 : 12);
    };

    window.addEventListener("resize", updateVisibleItems);

    return () => {
      window.removeEventListener("resize", updateVisibleItems);
    };
  }, []);

  useEffect(() => {
    const getCategories = async (id) => {
      try {
        const data = await fetchcategorylist(id);
        setCategories(data);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      } finally {
        setPageloading(false); // Set loading to false after data is fetched
      }
    };
    getCategories();
  }, []);

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    speed: 500,
    infinite: true,
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          "https://vishushethra.com/api/api/featured-products/",
        );
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);
  useEffect(() => {
    const fetchbestsellerProducts = async () => {
      try {
        const response = await axios.get(
          "https://vishushethra.com/api/api/best-sellers/",
        );
        setBestsellerProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchbestsellerProducts();
  }, []);
  useEffect(() => {
    const fetchlatestcollection = async () => {
      try {
        const response = await axios.get(
          "https://vishushethra.com/api/api/latest-collection/",
        );
        setLatestcollection(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchlatestcollection();
  }, []);

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqItems = [
    {
      question: "Why choose Vishushetra steel products?",
      answer:
        "Vishushetra steel products are manufactured using high-quality raw materials and advanced processes to ensure strength, durability, and long service life. Our products meet industry standards and are trusted for construction, fabrication, and industrial applications.",
    },
    {
      question: "What makes Vishushetra steel plates unique?",
      answer:
        "Our steel plates are precision-engineered for uniform thickness, excellent load-bearing capacity, and superior resistance to wear and corrosion. This makes them suitable for heavy-duty and long-term usage across multiple industries.",
    },
    {
      question: "Are Vishushetra steel products suitable for industrial use?",
      answer:
        "Yes, Vishushetra steel products are widely used in industrial, construction, and fabrication sectors. They are designed to perform reliably under demanding conditions and comply with modern industrial requirements.",
    },
    {
      question: "Do you ensure quality control for steel products?",
      answer:
        "Every Vishushetra steel product undergoes strict quality checks to ensure consistency, strength, and safety. Our commitment to quality ensures dependable performance in every project.",
    },
  ];

  const [selectedProduct, setSelectedProduct] = useState(null);

  const [favorites, setFavorites] = useState([]);

  const toggleFavorite = (productId) => {
    if (favorites.includes(productId)) {
      setFavorites(favorites.filter((id) => id !== productId)); // Remove from favorites
    } else {
      setFavorites([...favorites, productId]); // Add to favorites
    }
  };
  const handleAddToFavorites = async (productId) => {
    const userId = localStorage.getItem("userId"); // Get userId from local storage
    if (userId) {
      try {
        await createFavorite(userId, productId);

        Swal.fire({
          icon: "success",
          title: "Add Cart",
          text: "Product added to favorites successfully",
        });
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to add favorites.",
        });
        console.error("Error adding to favorites:", error);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please log in to add favorites.",
      });
    }
  };
  if (pageloading) {
    return <Loading />;
  }

  // Fallback image used whenever a product has no images array / empty images
  const FALLBACK_IMAGE = "default-image.jpg";

  return (
    <div>
      <section className="slider_section mb-0">
        <Slider {...settings} className="slider_area">
          <div>
            <div className="single_slider d-flex align-items-center banner">
              <div className="container">
                <div className="row justify-content-start">
                  <div className="col-lg-7 col-md-5 ">
                    <div
                      className="slider_text d-flex flex-column align-items-center justify-content-center text-center mt-5"
                      style={{
                        color: "white",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        padding: "20px",
                      }}
                    >
                      <h1>
                        Premium steel plates
                        <br></br> built for strength
                        <br></br> and durability.
                      </h1>

                      <Link
                        className="btn btn-primary"
                        to="/Latestcollection"
                        style={{ marginTop: "0px" }}
                      >
                        Shop Now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="single_slider d-flex align-items-center banner1">
              <div className="container">
                <div className="row justify-content-start">
                  <div className="col-lg-5 col-md-7 ">
                    <div
                      className="slider_text d-flex flex-column align-items-center justify-content-left text-center mt-5"
                      style={{
                        color: "white",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        padding: "20px",
                      }}
                    >
                      <h1>
                        Precision steel solutions <br></br>for modern
                        industries.
                      </h1>

                      <Link
                        className="btn btn-primary"
                        to="/Latestcollection"
                        style={{ marginTop: "0px" }}
                      >
                        Shop Now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="single_slider d-flex align-items-center banner2">
              <div className="container">
                <div className="row justify-content-end">
                  <div className="col-lg-7 col-md-7 ">
                    <div
                      className="slider_text d-flex flex-column align-items-center justify-content-center text-center mt-5"
                      style={{
                        color: "white",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        padding: "20px",
                      }}
                    >
                      <h1>
                        Trusted steel products <br></br> for every project.
                      </h1>

                      <Link
                        className="btn btn-primary"
                        to="/Latestcollection"
                        style={{ marginTop: "0px" }}
                      >
                        Shop Now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </section>

      <section className="product_area related_products mb-20 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-12 mt-2">
              <div className="section_title mb-25 ">
                <h2>Shop By Category</h2>
              </div>
            </div>
          </div>

          <div className="product_container row">
            {categories.map((category) => (
              <div className="col-lg-3" key={category.id}>
                <article className="single_product" id="Categorycard">
                  <figure>
                    <div className="product_thumb">
                      <Link to={`/product/${category.id}`}>
                        <img
                          className="primary_img"
                          src={category.image || "default-image.jpg"} // Default image fallback
                          alt={category.name}
                        />
                      </Link>
                    </div>
                    <figcaption className="product_content text-center">
                      <h4 className="product_name">
                        <Link to={`/category/${category.id}`}>
                          {category.name}
                        </Link>
                      </h4>
                    </figcaption>
                  </figure>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="product_area related_products mb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section_title mb-50">
                <h2>Our Trending products</h2>
              </div>
            </div>
          </div>

          <div className="grid-container">
            {[...latestcollection]
              .reverse()
              .slice(0, visibleItems)
              .map((product) => {
                const originalPrice = parseFloat(product.price);
                const discountedPrice =
                  originalPrice -
                  (originalPrice * product.discount_percentage) / 100;
                const hasImages =
                  Array.isArray(product.images) && product.images.length > 0;

                return (
                  <div key={product.id} className="grid-item">
                    <div className="product-thumb">
                      <Link to={`/Productdetail/${product.id}`}>
                        {/* Primary Image */}
                        <img
                          className="primary-img"
                          src={
                            hasImages
                              ? product.images[0].image
                              : FALLBACK_IMAGE
                          }
                          alt={product.name}
                        />
                        {/* Secondary Image (Only show if available) */}
                        {hasImages && product.images[1] && (
                          <img
                            className="secondary-img"
                            src={product.images[1].image}
                            alt={`${product.name} hover`}
                          />
                        )}
                      </Link>

                      <div className="product-labels">
                        {product.offer_type === "buy_x_get_y" && (
                          <div className="product-label bogo">
                            <span>
                              Buy {product.buy_x} Get {product.get_y}
                            </span>
                          </div>
                        )}
                        {product.offer_type === "discount_percentage" &&
                          product.discount_percentage !== "0.00" && (
                            <div className="product-label discount">
                              <span>-{product.discount_percentage}%</span>
                            </div>
                          )}
                        {product.sold_out && (
                          <div className="product-label sold-out">
                            <span>Sold Out</span>
                          </div>
                        )}
                        {product.coming_soon && (
                          <div className="product-label coming-soon">
                            <span>Coming Soon</span>
                          </div>
                        )}
                        {product.latest_collection && (
                          <div className="product-label latest">
                            <span>Trending</span>
                          </div>
                        )}
                      </div>

                      <div className="product-action">
                        <ul>
                          <li
                            className="wishlist"
                            onClick={() => {
                              handleAddToFavorites(product.id);
                              toggleFavorite(product.id);
                            }}
                          >
                            <Link to="" title="Wishlist">
                              {favorites.includes(product.id) ? (
                                <FaHeart className="wishlist-icon active" />
                              ) : (
                                <FaRegHeart className="wishlist-icon" />
                              )}
                            </Link>
                          </li>
                          <li className="quick-view">
                            <Link
                              data-toggle="modal"
                              data-target="#modal_box"
                              title="Quick View"
                              to="#"
                              onClick={() => setSelectedProduct(product)}
                            >
                              <i className="icon-size-fullscreen icons"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="product-content">
                      <h4 className="product-name">
                        <Link to={`/Productdetail/${product.id}`}>
                          {product.name}
                        </Link>
                      </h4>
                      {!product.coming_soon && (
                        <div className="price-box">
                          <span className="current-price">
                            ₹
                            {discountedPrice.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                            })}{" "}
                            <span className="inr">INR</span>
                          </span>
                          {product.discount_percentage > 0 && (
                            <span className="old-price">
                              ₹
                              {originalPrice.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                              })}{" "}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="d-flex justify-content-center">
            <Link
              className="btn btn-primary d-flex align-items-center"
              to="/Latestcollection"
            >
              View all
            </Link>
          </div>
        </div>
      </section>

      <section className="accordion">
        <div className="accordion-left">
          <h1>FAQ</h1>
          <p>
            Discover answers to the most common questions about Coco Heal and
            Beauty Products. If you need further assistance, feel free to reach
            out to our friendly customer support team!
          </p>
        </div>
        <div className="accordion-right">
          {faqItems.map((item, index) => (
            <div key={index} className="accordion-item">
              <button
                className="accordion-header"
                onClick={() => toggleAccordion(index)}
              >
                <h3>{item.question}</h3>
              </button>
              <div
                className={`accordion-content ${
                  openIndex === index ? "open" : ""
                }`}
              >
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="product_area related_products mb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section_title mb-50">
                <h2>Best Seller Products</h2>
              </div>
            </div>
          </div>

          <div className="grid-container">
            {[...bestsellerProducts]
              .reverse()
              .slice(0, visibleItems)
              .map((product) => {
                const originalPrice = parseFloat(product.price);

                const discountedPrice =
                  originalPrice -
                  (originalPrice * product.discount_percentage) / 100;
                const hasImages =
                  Array.isArray(product.images) && product.images.length > 0;

                return (
                  <div key={product.id} className="grid-item">
                    <div className="product-thumb">
                      <Link to={`/Productdetail/${product.id}`}>
                        {/* Primary Image */}
                        <img
                          className="primary-img"
                          src={
                            hasImages
                              ? product.images[0].image
                              : FALLBACK_IMAGE
                          }
                          alt={product.name}
                        />
                        {/* Secondary Image (Only show if available) */}
                        {hasImages && product.images[1] && (
                          <img
                            className="secondary-img"
                            src={product.images[1].image}
                            alt={`${product.name} hover`}
                          />
                        )}
                      </Link>

                      <div className="product-labels">
                        {product.offer_type === "buy_x_get_y" && (
                          <div className="product-label bogo">
                            <span>
                              Buy {product.buy_x} Get {product.get_y}
                            </span>
                          </div>
                        )}
                        {product.offer_type === "discount_percentage" &&
                          product.discount_percentage !== "0.00" && (
                            <div className="product-label discount">
                              <span>-{product.discount_percentage}%</span>
                            </div>
                          )}
                        {product.sold_out && (
                          <div className="product-label sold-out">
                            <span>Sold Out</span>
                          </div>
                        )}
                        {product.coming_soon && (
                          <div className="product-label coming-soon">
                            <span>Coming Soon</span>
                          </div>
                        )}
                        {product.latest_collection && (
                          <div className="product-label latest">
                            <span>Trending</span>
                          </div>
                        )}
                      </div>
                      {/* Product Actions */}
                      <div className="product-action">
                        <ul>
                          <li
                            className="wishlist"
                            onClick={() => {
                              handleAddToFavorites(product.id);
                              toggleFavorite(product.id);
                            }}
                          >
                            <Link to="" title="Wishlist">
                              {favorites.includes(product.id) ? (
                                <FaHeart className="wishlist-icon active" />
                              ) : (
                                <FaRegHeart className="wishlist-icon" />
                              )}
                            </Link>
                          </li>
                          <li className="quick-view">
                            <Link
                              data-toggle="modal"
                              data-target="#modal_box"
                              title="Quick View"
                              to="#"
                              onClick={() => setSelectedProduct(product)}
                            >
                              <i className="icon-size-fullscreen icons"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="product-content">
                      <h4 className="product-name">
                        <Link to={`/Productdetail/${product.id}`}>
                          {product.name}
                        </Link>
                      </h4>
                      {!product.coming_soon && (
                        <div className="price-box">
                          <span className="current-price">
                            ₹
                            {discountedPrice.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                            })}{" "}
                            <span className="inr">INR</span>
                          </span>
                          {product.discount_percentage > 0 && (
                            <span className="old-price">
                              ₹
                              {originalPrice.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                              })}{" "}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="d-flex justify-content-center">
            <Link
              className="btn btn-primary d-flex align-items-center   "
              to="/Bestseller"
            >
              View all
            </Link>
          </div>
        </div>
      </section>

      <section className="testmonial">
        <div className="testmonial-text">
          <h1>Client Testimonials</h1>
          <p>
            Your trusted partner for premium steel solutions — hear from our
            satisfied customers.
          </p>
          <Swiper
            spaceBetween={50}
            slidesPerView={1}
            pagination={{ clickable: true }}
            navigation={false}
            autoplay={{ delay: 3000 }}
            loop={true}
            modules={[Pagination, Navigation, Autoplay]}
          >
            <SwiperSlide>
              <div>
                <p>
                  Vishushetra steel plates are exceptionally strong and
                  reliable. The quality consistency has helped us complete our
                  projects on time without any issues.
                </p>
                <h5>Barathidhasan</h5>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <p>
                  We have been sourcing steel products from Vishushetra for a
                  long time. Their materials meet industry standards and the
                  service is always professional.
                </p>
                <h5>Mugilesh</h5>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div>
                <p>
                  Excellent quality steel with precise finishing. Vishushetra
                  has become our preferred supplier for all fabrication and
                  construction requirements.
                </p>
                <h5>Praveen</h5>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>

      <section className="product_area related_products mb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section_title mb-50">
                <h2>featured Products</h2>
              </div>
            </div>
          </div>

          <div className="grid-container">
            {[...products]
              .reverse()
              .slice(0, visibleItems)
              .map((product) => {
                const originalPrice = parseFloat(product.price);

                const discountedPrice =
                  originalPrice -
                  (originalPrice * product.discount_percentage) / 100;
                const hasImages =
                  Array.isArray(product.images) && product.images.length > 0;

                return (
                  <div key={product.id} className="grid-item">
                    <div className="product-thumb">
                      <Link to={`/Productdetail/${product.id}`}>
                        {/* Primary Image */}
                        <img
                          className="primary-img"
                          src={
                            hasImages
                              ? product.images[0].image
                              : FALLBACK_IMAGE
                          }
                          alt={product.name}
                        />
                        {/* Secondary Image (Only show if available) */}
                        {hasImages && product.images[1] && (
                          <img
                            className="secondary-img"
                            src={product.images[1].image}
                            alt={`${product.name} hover`}
                          />
                        )}
                      </Link>

                      <div className="product-labels">
                        {product.offer_type === "buy_x_get_y" && (
                          <div className="product-label bogo">
                            <span>
                              Buy {product.buy_x} Get {product.get_y}
                            </span>
                          </div>
                        )}
                        {product.offer_type === "discount_percentage" &&
                          product.discount_percentage !== "0.00" && (
                            <div className="product-label discount">
                              <span>-{product.discount_percentage}%</span>
                            </div>
                          )}
                        {product.sold_out && (
                          <div className="product-label sold-out">
                            <span>Sold Out</span>
                          </div>
                        )}
                        {product.coming_soon && (
                          <div className="product-label coming-soon">
                            <span>Coming Soon</span>
                          </div>
                        )}
                        {product.latest_collection && (
                          <div className="product-label latest">
                            <span>Trending</span>
                          </div>
                        )}
                      </div>
                      {/* Product Actions */}
                      <div className="product-action">
                        <ul>
                          <li
                            className="wishlist"
                            onClick={() => {
                              handleAddToFavorites(product.id);
                              toggleFavorite(product.id);
                            }}
                          >
                            <Link to="" title="Wishlist">
                              {favorites.includes(product.id) ? (
                                <FaHeart className="wishlist-icon active" />
                              ) : (
                                <FaRegHeart className="wishlist-icon" />
                              )}
                            </Link>
                          </li>
                          <li className="quick-view">
                            <Link
                              data-toggle="modal"
                              data-target="#modal_box"
                              title="Quick View"
                              to="#"
                              onClick={() => setSelectedProduct(product)}
                            >
                              <i className="icon-size-fullscreen icons"></i>
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="product-content">
                      <h4 className="product-name">
                        <Link to={`/Productdetail/${product.id}`}>
                          {product.name}
                        </Link>
                      </h4>
                      {!product.coming_soon && (
                        <div className="price-box">
                          <span className="current-price">
                            ₹
                            {discountedPrice.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                            })}{" "}
                            <span className="inr">INR</span>
                          </span>
                          {product.discount_percentage > 0 && (
                            <span className="old-price">
                              ₹
                              {originalPrice.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                              })}{" "}
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
          </div>

          <div className="d-flex justify-content-center">
            <Link
              className="btn btn-primary d-flex align-items-center   "
              to="/Featured"
            >
              View all
            </Link>
          </div>
        </div>
      </section>

      <div
        className="modal fade"
        id="modal_box"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">
                <i className="ion-android-close"></i>
              </span>
            </button>
            {selectedProduct && (
              <div className="modal_body">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="modal_zoom_gallery">
                        <div className="big_image_container">
                          <img
                            id="bigImage"
                            src={
                              Array.isArray(selectedProduct.images) &&
                              selectedProduct.images.length > 0
                                ? selectedProduct.images[0].image
                                : FALLBACK_IMAGE
                            } // Use selected product image
                            alt={selectedProduct.name}
                            className="big_image"
                          />
                        </div>
                        <div className="small_images_container">
                          {Array.isArray(selectedProduct.images) &&
                            selectedProduct.images.map((img, index) => (
                              <img
                                key={index}
                                src={img.image}
                                alt={selectedProduct.name}
                                className="small_image"
                                onClick={() =>
                                  (document.getElementById("bigImage").src =
                                    img.image)
                                }
                              />
                            ))}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="modal_right">
                        <div className="modal_title mb-10">
                          <h2>{selectedProduct.name}</h2>
                        </div>
                        <div className="modal_price mb-10 d-flex  align-items-center g-3">
                          <h5>Price</h5>
                          <span className="new_price ml-3">
                            ₹{selectedProduct.price}INR
                          </span>{" "}
                        </div>
                        <div className="modal_description mb-15 d-flex  align-items-center g-3">
                          <h5>description</h5>
                          <p className="ml-3">{selectedProduct.description}</p>
                        </div>
                        <div className="modal_description mb-15 d-flex  align-items-center g-3">
                          <h5>fabric</h5>
                          <p className="ml-3">{selectedProduct.fabric}</p>
                        </div>
                        <div className="modal_description mb-15 d-flex  align-items-center g-3">
                          <h5>style</h5>
                          <p className="ml-3">{selectedProduct.style}</p>
                        </div>
                        <div className="modal_description mb-15 d-flex  align-items-center g-3">
                          <h5>Model wearing height</h5>
                          <p className="ml-3">{selectedProduct.model_height}</p>
                        </div>
                        <div className="modal_description mb-15 d-flex  align-items-center g-3">
                          <h5>Model wearing size</h5>
                          <p className="ml-3">
                            {selectedProduct.model_wearing_size}
                          </p>
                        </div>

                        <button
                          className="button btn btn-success py-2"
                          type="button"
                        >
                          Go to Product detail page
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <Notification />

      <Subscribe />

      <WhatsAppChatWidget
        phoneNumber="+918939711577"
        companyName="VishuShethra Industries"
      />
    </div>
  );
};

export default Home;